import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IconType } from 'react-icons';
import {
    FaHome, FaCalendarAlt, FaBookOpen, FaChartPie, FaWallet, FaCog
} from 'react-icons/fa';
import { useI18n } from '../contexts/I18nContext';
import '../styles/Layout.css';

interface NavItem {
    path: string;
    icon: IconType;
    labelKey: keyof import('../i18n').Strings;
}

const NAV_ITEMS: NavItem[] = [
    { path: '/', icon: FaHome, labelKey: 'nav.dashboard' },
    { path: '/schedule', icon: FaCalendarAlt, labelKey: 'nav.schedule' },
    { path: '/courses', icon: FaBookOpen, labelKey: 'nav.courses' },
    { path: '/skills', icon: FaChartPie, labelKey: 'nav.skills' },
    { path: '/finance', icon: FaWallet, labelKey: 'nav.finance' },
    { path: '/settings', icon: FaCog, labelKey: 'nav.settings' },
];

const Sidebar: React.FC = () => {
    const location = useLocation();
    const { t } = useI18n();

    return (
        <div className="sidebar">
            {/* Logo - 僅顯示圖示，對齊 TaskyVenture */}
            <div className="sidebar-logo">
                <img src="/favicon.ico" alt={t('app.appName')} className="app-logo" />
            </div>

            {/* 導覽 */}
            <nav className="sidebar-nav">
                <ul>
                    {NAV_ITEMS.map(({ path, icon: Icon, labelKey }) => {
                        const isActive = path === '/'
                            ? location.pathname === '/'
                            : location.pathname.startsWith(path);
                        return (
                            <li key={path} className={isActive ? 'active' : ''}>
                                <Link to={path} aria-label={t(labelKey)} title={t(labelKey)}>
                                    <span className="menu-icon">{React.createElement(Icon as any)}</span>
                                    <span className="nav-tooltip">{t(labelKey)}</span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </div>
    );
};

export default Sidebar;
